<div class="ui vertical segment" id="scroll-container">
  <table class="ui single line table">
    <thead>
      <tr>
        <th>Document Type</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let affiliateType of affiliateTypes">
        <td>
          {{ affiliateType.documentTypeName }}
        </td>
      </tr>
    </tbody>
    <app-no-record-found
      *ngIf="affiliateTypes && affiliateTypes.length < 1"
    ></app-no-record-found>
  </table>
</div>
